/*
 * MIST basket upsell (snippets/mist-cart-upsell.liquid).
 * "+ Flavour" / "Add pack": add one pack, tag the cart with `_mist_upsell` (which nudge was used, so orders can be
 * measured), then repaint the drawer (or reload /cart).
 */
(() => {
  const post = (url, body) =>
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then((r) => {
      if (!r.ok) throw new Error(`${url} ${r.status}`);
      return r.json();
    });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest?.('[data-mist-upsell-add]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;
    event.preventDefault();

    const select = button.closest('.mist-upsell')?.querySelector('[data-mist-upsell-select]');
    const id = Number(button.dataset.variantId || select?.value);
    if (!id) return;

    button.setAttribute('aria-busy', 'true');
    try {
      await post('/cart/add.js', { items: [{ id, quantity: 1 }] });
      await post('/cart/update.js', { attributes: { _mist_upsell: button.dataset.mistUpsellAdd } });
    } catch (error) {
      console.error(error);
    }

    const drawer = document.querySelector('cart-drawer');
    if (drawer && button.closest('cart-drawer') && typeof drawer.refresh === 'function') {
      await drawer.refresh();
    } else {
      window.location.reload();
    }
  });
})();
